(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nido-cookie-preferences"] && !Shopify.designMode) return;
  try {
    if (!window.nidoCookiePreferencesBound) {
    window.nidoCookiePreferencesBound = true;
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-nido-cookie-preferences]');
      if (!link || event.defaultPrevented || event.button > 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
      event.preventDefault();
      const fallback = function () { window.location.assign(link.href); };
      try {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(fallback);
      } catch (_) { fallback(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nido-design"] && !Shopify.designMode) return;
  try {
    (()=>{
  let observer;
  const signupTimers = new WeakMap();
  function resetSignup(form) {
    clearTimeout(signupTimers.get(form));
    signupTimers.delete(form);
    form.removeAttribute('aria-busy');
    const feedback=form.closest('.nidoFirstBatch')?.querySelector('[data-signup-feedback]');
    if(feedback) {
      feedback.hidden=true;
      feedback.querySelector('[data-signup-help]').hidden=true;
    }
  }
  function prepareSignup(form) {
    if(form.dataset.submitReady) return;
    form.dataset.submitReady='true';
    form.addEventListener('submit',()=>{
      resetSignup(form);
      form.setAttribute('aria-busy','true');
      const feedback=form.closest('.nidoFirstBatch')?.querySelector('[data-signup-feedback]');
      if(feedback) {
        feedback.querySelector('[data-signup-message]').textContent=feedback.dataset.pending;
        feedback.hidden=false;
      }
      signupTimers.set(form,setTimeout(()=>{
        signupTimers.delete(form);
        form.removeAttribute('aria-busy');
        if(!form.isConnected || !feedback) return;
        feedback.querySelector('[data-signup-message]').textContent=feedback.dataset.delayed;
        feedback.querySelector('[data-signup-help]').hidden=false;
      },20000));
    });
  }
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  function revealAll() {
    document.querySelectorAll('.reveal,[data-word-reveal]').forEach(el=>el.classList.add('is-visible'));
    document.documentElement.classList.remove('motion-ready');
    observer?.disconnect();
  }
  function init(root=document) {
    if (!motion.matches && 'IntersectionObserver' in window) {
      observer ||= new IntersectionObserver(entries=>entries.forEach(entry=>{
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), {threshold:.1,rootMargin:'0px 0px -4% 0px'});
      root.querySelectorAll('[data-word-reveal]:not([data-words-prepared])').forEach(el=>{
        const copy=el.cloneNode(true);
        copy.querySelectorAll('br').forEach(br=>br.replaceWith(' '));
        el.setAttribute('aria-label',(el.innerText||copy.textContent).replace(/\s+/g,' ').trim());
        const walk=document.createTreeWalker(el,NodeFilter.SHOW_TEXT), nodes=[];
        while(walk.nextNode()) nodes.push(walk.currentNode);
        let index=0;
        nodes.forEach(node=>{
          const fragment=document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(word=>{
            if(!word.trim()) { fragment.append(word); return; }
            const span=document.createElement('span');
            span.className='wordReveal';
            span.style.setProperty('--word-index',index++);
            span.setAttribute('aria-hidden','true');
            span.textContent=word;
            fragment.append(span);
          });
          node.replaceWith(fragment);
        });
        el.dataset.wordsPrepared='true';
      });
      root.querySelectorAll('.reveal,[data-word-reveal]').forEach(el=>{
        if(el.closest('.revealCritical')) el.classList.add('is-visible');
        else if(!el.classList.contains('is-visible')) observer.observe(el);
      });
      document.documentElement.classList.add('motion-ready');
    }
    root.querySelectorAll('[data-material]:not([data-ready])').forEach(el=>{
      el.dataset.ready='true';
      const tabs=[...el.querySelectorAll('[role=tab]')], panels=[...el.querySelectorAll('[role=tabpanel]')], images=[...el.querySelectorAll('[data-material-image]')];
      const choose=index=>tabs.forEach((tab,i)=>{
        tab.setAttribute('aria-selected',index===i);
        tab.tabIndex=index===i?0:-1;
        panels[i].hidden=index!==i;
        images[i].hidden=index!==i;
      });
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>choose(index));
        tab.addEventListener('keydown',event=>{
          let next=index;
          if(event.key==='ArrowRight') next=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft') next=(index+tabs.length-1)%tabs.length;
          else if(event.key==='Home') next=0;
          else if(event.key==='End') next=tabs.length-1;
          else return;
          event.preventDefault(); choose(next); tabs[next].focus();
        });
      });
    });
    root.querySelectorAll('.nidoMobile:not([data-ready])').forEach(el=>{
      el.dataset.ready='true';
      el.addEventListener('keydown',event=>{
        if(event.key==='Escape') { el.open=false; el.querySelector('summary').focus(); }
      });
      el.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{el.open=false}));
      el.addEventListener('focusout',()=>requestAnimationFrame(()=>{
        if(!el.contains(document.activeElement)) el.open=false;
      }));
    });
    root.querySelectorAll('.nidoFirstBatch form:not([data-submit-ready])').forEach(prepareSignup);
    const path=location.pathname.replace(/\/$/,'')||'/';
    root.querySelectorAll('.nav a,.nidoMobile nav a').forEach(link=>{
      const url=new URL(link.href,location.href);
      if(!url.hash && (url.pathname.replace(/\/$/,'')||'/')===path) link.setAttribute('aria-current','page');
    });
  }
  let frame=0;
  function updateHeader() {
    frame=0;
    document.querySelector('.siteHeader')?.classList.toggle('is-scrolled',scrollY>20);
  }
  window.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(updateHeader)},{passive:true});
  document.addEventListener('click',event=>{
    document.querySelectorAll('.nidoMobile[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false});
    const link=event.target.closest('a[href*="#"]');
    if(!link)return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
    const target=document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if(target?.matches('form'))requestAnimationFrame(()=>target.querySelector('input[type=email]')?.focus({preventScroll:true}));
  });
  window.addEventListener('pageshow',()=>document.querySelectorAll('.nidoFirstBatch form').forEach(resetSignup));
  motion.addEventListener('change',()=>{if(motion.matches)revealAll();else init()});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init();updateHeader()});else {init();updateHeader()}
  document.addEventListener('shopify:section:load',event=>{init(event.target);updateHeader()});
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('.reveal,[data-word-reveal]').forEach(el=>observer?.unobserve(el));
    event.target.querySelectorAll('.nidoFirstBatch form').forEach(resetSignup);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nido-hero-gallery"] && !Shopify.designMode) return;
  try {
    function initNidoHero(root=document){
 root.querySelectorAll('[data-hero-gallery]:not([data-ready])').forEach(gallery=>{
  gallery.dataset.ready='true';const track=gallery.querySelector('.nidoHeroTrack'),slides=[...track.children],controls=gallery.querySelector('.nidoHeroControls');if(slides.length<2)return;
  const prev=gallery.querySelector('[data-gallery-prev]'),next=gallery.querySelector('[data-gallery-next]'),count=gallery.querySelector('[data-gallery-count]'),progress=gallery.querySelector('[data-gallery-progress]');controls.hidden=false;
  let requested=0,current=0,frame=0;
  const index=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
  const update=()=>{frame=0;current=index();prev.disabled=current===0;next.disabled=current===slides.length-1;count.textContent=String(current+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');if(progress)progress.style.transform='scaleX('+((current+1)/slides.length)+')';slides.forEach((slide,i)=>slide.setAttribute('aria-hidden',String(i!==current)))};
  const move=target=>{requested=Math.max(0,Math.min(slides.length-1,target));track.scrollTo({left:requested*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
  prev.addEventListener('click',()=>move(requested-1));next.addEventListener('click',()=>move(requested+1));
  track.addEventListener('pointerdown',()=>{requested=index()});
  track.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update)},{passive:true});
  track.addEventListener('scrollend',()=>{requested=index();update()});
  track.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight')move(requested+1);
    else if(event.key==='ArrowLeft')move(requested-1);
    else if(event.key==='Home')move(0);
    else if(event.key==='End')move(slides.length-1);
    else return;
    event.preventDefault();
  });
  if('ResizeObserver' in window){const resize=new ResizeObserver(()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'});requested=current});resize.observe(track);gallery.nidoResize=resize}
  update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initNidoHero());else initNidoHero();document.addEventListener('shopify:section:load',e=>initNidoHero(e.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hero-gallery]').forEach(gallery=>gallery.nidoResize?.disconnect()));
  } catch(e) { console.error(e); }
})();

})();
